// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Tilbake',
    title: 'Regel krav',
    role: 'Rolle',
    save: 'Lagre',
}